<template>
  <div class="header ">
    <div class="container">
      <a href="#" class="js-hover logo" data-target="js-shop-info">
        <span>子衿优品商城</span>
      </a>

      <!-- 用户信息 -->
      <span v-if="loginMobile" class="user-phone" @click="logout">退出登录</span>
      <span v-if="loginMobile" class="user-phone">{{ loginMobile }}</span>
      <span v-if="loginMobile" @click="toOrder" class="user-phone user-order"
        >订单中心</span
      >
      <ElButton
        v-else
        style="margin-left: 15px"
        type="info"
        size="mini"
        @click="loginDialog"
        >未登录</ElButton
      >

      <!-- 用户登录对话框 -->
      <ElDialog title="用户登录" v-model="dialogFormVisible" width="550px">
        <ElForm :model="form" label-width="100px">
          <ElFormItem required label="手机号">
            <ElInput
              placeholder="请输入手机号"
              v-model="form.phone"
              autocomplete="off"
            />
          </ElFormItem>
          <ElFormItem required label="验证码">
            <ElInput
              placeholder="请输入验证码"
              style="width:250px;margin-right:15px"
              v-model="form.code"
              autocomplete="off"
            />
            <ElButton @click="getCode">{{
              sendingSecond ? `重新发送${sendingSecond}s` : '获取验证码'
            }}</ElButton>
          </ElFormItem>
        </ElForm>
        <template #footer>
          <span class="dialog-footer">
            <ElButton @click="dialogFormVisible = false">取 消</ElButton>
            <ElButton type="primary" @click="submitForm">登 录</ElButton>
          </span>
        </template>
      </ElDialog>
    </div>
  </div>
</template>
<script>
import {
  ElButton,
  ElDialog,
  ElForm,
  ElFormItem,
  ElInput,
  ElMessage,
} from 'element-plus'
import { sendCode, checkCode } from '@/api/shopHeader'
import { setCookie, getCookie } from '@/utils/cookie'
import { mapState } from 'vuex'
export default {
  components: { ElButton, ElDialog, ElForm, ElFormItem, ElInput },
  data() {
    return {
      dialogFormVisible: false,
      form: {
        phone: '', // 手机号
        code: '', // 验证码
      },
      sendingSecond: null,
      setTimer: null,
    }
  },
  computed: {
    ...mapState('root', ['loginMobile', 'isOpenLogin']),
  },
  watch: {
    isOpenLogin(newval) {
      if (newval) {
        this.loginDialog()
      }
    },
  },
  mounted() {
    this.$store.commit('root/setLoginMobile', getCookie('phone'))
  },
  methods: {
    loginDialog() {
      this.dialogFormVisible = true
      this.$store.commit('root/setIsOpenLogin', false)
    },
    // 获取验证码
    async getCode() {
      if(this.sendingSecond){
        return
      }
      const rules = /^1(3|4|5|6|7|8|9)\d{9}$/.test(this.form.phone)
      if (!rules) return ElMessage.warning('请输入正确手机号')
      const res = await sendCode(this.form.phone)
      if (res.code !== 200) {
        this.sendingSecond = null
        return ElMessage.warning('短信发送失败')
      } else {
        this.sendingSecond = 60
        this.startTime()
        ElMessage.success('短信发送成功')
      }
    },
    // 校验验证码，登录
    async submitForm() {
      const rules = /^1(3|4|5|6|7|8|9)\d{9}$/.test(this.form.phone)
      if (!rules) return ElMessage.warning('请输入正确手机号')
      const res = await checkCode({
        phone: this.form.phone,
        code: this.form.code,
      })
      if (res.code !== 200) return ElMessage.warning(res.msg)
      clearInterval(this.setTimer)
      this.sendingSecond = null
      ElMessage.success('登录成功')
      setCookie('phone', this.form.phone, 1)
      this.$store.commit('root/setLoginMobile', this.form.phone)
      this.dialogFormVisible = false
    },
    startTime() {
      clearInterval(this.setTimer)
      setInterval(() => {
        if (this.sendingSecond === 0) {
          clearInterval(this.sendingSecond)
          return
        }
        this.sendingSecond -= 1
      }, 1000)
    },
    logout() {
      this.$store.commit('root/setLoginMobile', '')
      setCookie('phone', '', -1)
    },
    toOrder() {
      this.$router.push('/orderList')
    },
  },
}
</script>
<style scoped>
.user-order {
  cursor: pointer;
}
.header {
  background-color: #1f292c;
  height: 50px;
  line-height: 50px;
  position: relative;
}

.header.header-mt {
  margin-top: 53px;
}

.header a {
  color: #f7f7f7;
  display: inline-block;
  height: 50px;
}

.header .logo {
  font-size: 18px;
}

.header .smaller-title {
  font-size: 12px;
  margin-left: 10px;
}

.header .nav {
  font-size: 12px;
  display: inline-block;
}

.header .nav li {
  display: inline-block;
}

.header .nav .separate {
  font-size: 12px;
  color: #999;
  margin: 0 10px;
}

.header .icon-wxv {
  vertical-align: middle;
}
.container {
  text-align: left;
  width: 1000px;
  margin: 0 auto;
}

.header .container .user-phone {
  float: right;
  font-size: 12px;
  color: #f7f7f7;
  margin: 0 10px;
}

@media screen and (min-width: 1160px) {
  .container {
    width: 1160px;
  }
}
</style>
